import HasRole from "modules/5_view_helpers/HasRole";
import { createCustomFormLinks, createMenuItems } from "./helpers";

const getDrawingOfficeNav = (project_id, drawing_office_custom_forms, drawing_office_menus) => {
  let items = [];

  items.push({
    icon: "fa fa-home",
    label: "Drawing Office",
    to: `/drawing_office`,
  });

  const SiteDocumentReleaseRoles = HasRole({
    resource_type: "Project::SiteDocumentRelease",
  });
  const ProjectDrawingRole = HasRole({
    resource_type: "Project::Drawing",
  });
  const DrawingTypesRoles = HasRole({
    resource_type: "DrawingOffice::DrawingType",
  });
  const WorkPackageStatusesRoles = HasRole({
    resource_type: "DrawingOffice::WorkPackageStatus",
  });
  const CommunicationsStatusesRoles = HasRole({ resource_type: "Project::Communications::Status", name: ["read", "moderator"] });
  const CommunicationsOutgoingTypesRoles = HasRole({ resource_type: "Project::Communications::OutgoingType", name: ["read", "moderator"] });

  const WorkPackagesRoles = HasRole({ resource_type: "Project::DrawingOffice::WorkPackage", name: ["read", "moderator"] });
  const IfasRoles = HasRole({ resource_type: "Project::DrawingOffice::Ifa", name: ["read", "moderator"] });
  const IffsRoles = HasRole({ resource_type: "Project::DrawingOffice::Iff", name: ["read", "moderator"] });

  if (SiteDocumentReleaseRoles) {
    items.push({
      label: "Site Document Releases",
      to: `/project/${project_id}/site_document_releases`,
      icon: "fa fa-file",
    });
  }
  if (ProjectDrawingRole) {
    items.push({
      label: "Drawings",
      to: `/project/${project_id}/drawings`,
      icon: "fa fa-pencil",
    });
  }

  if (WorkPackagesRoles) {
    items.push({
      label: "Work Packages",
      to: `/project/drawing_office/work_packages`,
      icon: "fa fa-tasks",
    });
  }

  if (IfasRoles) {
    items.push({
      label: "IFAs",
      to: `/project/${project_id}/drawing_office/ifas`,
      icon: "fa fa-list-ol",
    });
  }

  if (IffsRoles) {
    items.push({
      label: "IFFs",
      to: `/project/${project_id}/drawing_office/iffs`,
      icon: "fa fa-list-alt",
    });
  }

  const SettingsRoles = DrawingTypesRoles || WorkPackageStatusesRoles || CommunicationsStatusesRoles || CommunicationsOutgoingTypesRoles;
  if (SettingsRoles) {
    items.push({
      label: "Settings",
      to: `/drawing_office/settings`,
      icon: "fa fa-cog",
    });
  }



  items = _.concat(items, createCustomFormLinks(drawing_office_custom_forms), createMenuItems(drawing_office_menus));

  items.push({
    icon: "fa fa-arrow-left",
    label: "Back To Lion",
    external: true,
    to: `/`,
  });

  return items;
};

export default getDrawingOfficeNav;
